import React from 'react';

import {CardNetworkAsset} from '@primer-io/checkout-web';

import classNames from 'classnames';

import {useFeature} from 'components/feature';

import {PaymentCvvTooltip} from '../../../paymentCvvTooltip/paymentCvvTooltip';
import {
    primerCardExpiryOptions,
    primerCardNumberOptions,
    primerCardSecurityCodeOptions,
} from '../../constants';

import s from './primerForm.scss';

type PropsType = {
    isReady: boolean;
    cardNetwork: CardNetworkAsset | null;
};

/**
 * Primer form which contains fields that should be replaced by iframes
 */
export const PrimerForm = ({cardNetwork, isReady}: PropsType) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    return (
        <form className={classNames(s.container, {[s.containerFacelift]: isFacelift})}>
            {isReady && (
                <div className={classNames(s.cardNetwork, {[s.cardNetworkFaceLift]: isFacelift})}>
                    {cardNetwork && (
                        // eslint-disable-next-line react/forbid-elements
                        <img
                            alt={cardNetwork.displayName}
                            src={cardNetwork.cardUrl}
                            title={cardNetwork.displayName}
                        />
                    )}
                </div>
            )}
            <div className={s.cardNumber} id={primerCardNumberOptions.id} />
            <div className={s.cardExpiry} id={primerCardExpiryOptions.id} />
            <div className={s.cardCode} id={primerCardSecurityCodeOptions.id} />
            {isReady && <PaymentCvvTooltip />}
        </form>
    );
};
